module.exports = __webpack_public_path__ + "img/Global Stickers.2cb054ce.svg";